import { Component, OnInit } from '@angular/core';
import ApexCharts from 'apexcharts';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { DateUtil, MathUtil } from 'src/app/common/util';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';

@Component({
  selector: 'app-sale-invoice-detail-chart',
  templateUrl: './sale-invoice-detail-chart.component.html',
  styleUrls: ['./sale-invoice-detail-chart.component.scss']
})
export class SaleInvoiceDetailChartComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  warehouse = null;
  warehouses: WarehouseResponse[] = [];
  loadingChart = false;
  results = [];

  constructor(
    private accountingService: AccountingReportService,
    private toastService: ToastrService,
    private warehouseService: WarehouseService
  ) {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getWarehouses();
  }

  order(rows: any[]) {
    if (this.type == 0) {
      return rows;
    } else {
      rows.sort((a, b) => {
        if (this.type == 1) {
          return a.year - b.year;
        } else if (this.type == 2 || this.type == 3) {
          const dateA = new Date(a.month);
          const dateB = new Date(b.month);
          return dateA.getTime() - dateB.getTime();
        }
      });
      return rows;
    }
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.warehouse = this.warehouses[0].id;
        this.updateChart();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  updateChart() {
    if (this.warehouse != null) {
      this.loadingChart = true;
      document.getElementById("sale-invoice-detail")['innerHTML'] = "";
      this.accountingService.getSaleInvoiceDetail(
        this.warehouse,
        DateUtil.parseDateToMilliseconds(this.start),
        DateUtil.parseDateToMilliseconds(this.end)
      ).subscribe({
        next: (response: ResponseObject) => {
          var total = [];
          var categories = [];
          response.data = this.order(response.data);
          this.results = response.data;
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (this.type == 0 && element.day == null && element.month == null && element.year == null) {
              categories.push("TOTAL");
            } else if (this.type == 1 && element.day == null && element.month == null && element.year != null) {
              categories.push(element.year);
            } else if (this.type == 2 && element.day == null && element.month != null) {
              categories.push(element.month);
            } else if (this.type == 3 && element.day != null) {
              categories.push(element.day);
            } else {
              continue;
            }
            total.push(element.total);
          }

          const options = {
            chart: {
              height: 350,
              type: total.length > 1 ? 'area' : 'bar',
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth'
            },
            series: [{
              name: 'Total',
              data: total
            }],
            xaxis: {
              type: 'Mes',
              categories: categories,
            },
            yaxis: {
              labels: {
                formatter: function (val) {
                  return MathUtil.formatCurrency(val);
                }
              }
            
            },
            legend: {
              offsetY: -10,
            }
          }
          const chart = new ApexCharts(
            document.querySelector("#sale-invoice-detail"),
            options
          );
          chart.render();
          this.loadingChart = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loadingChart = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.toastService.info("Selecciona una bodega primero");
    }
  }

}